export const UploadIcon = ({...props}) => {
    return (
        <>
            <svg
                width={18}
                height={17}
                fill="#3D3D3D"
                {...props}
            >
                <path
                    d="M6.058 3.942a.625.625 0 0 1 0-.885l2.5-2.5a.625.625 0 0 1 .885 0l2.5 2.5a.625.625 0 0 1-.884.885L9.626 2.508v9.325a.625.625 0 0 1-1.25 0V2.51L6.943 3.942a.626.626 0 0 1-.885 0ZM14 6.208a.625.625 0 0 0 0 1.25c1.314 0 1.875.561 1.875 1.875V13.5c0 1.314-.56 1.875-1.875 1.875H4c-1.314 0-1.875-.56-1.875-1.875V9.333c0-1.314.56-1.875 1.875-1.875a.625.625 0 0 0 0-1.25c-2.015 0-3.125 1.11-3.125 3.125V13.5c0 2.015 1.11 3.125 3.125 3.125h10c2.015 0 3.125-1.11 3.125-3.125V9.333c0-2.015-1.11-3.125-3.125-3.125Z"
                />
            </svg>
        </>
    );
}